// src/data/languages/wolof/categories/index.ts
import { CategoryDictionary } from '../../../../types/types';

import salutations from './salutations';
import {nombres} from './nombres';
import {temps} from './temps';
import {animaux} from './animaux';
import {famille} from './famille';
import {nourriture} from './nourritures';
import {couleurs} from './couleurs';
import {corps} from './corps';
import {verbes} from './verbes';
import {grammaire} from './grammaire';
import {objets} from './objets';

// L'alphabet est la première étape du sentier (vocabulaire gratuit) :
// on le sort de la grammaire pour qu'il n'y apparaisse pas une seconde fois.
const { 'Alphabet copte': alphabet, ...grammaireSansAlphabet } = grammaire as Record<string, any>;

export const categories: CategoryDictionary = {
  'Alphabet copte': alphabet,
  'Salutations et expressions courantes': salutations,
  'Nombres': nombres,
  'Temps': temps,
  'Animaux': animaux,
  'Famille': famille,
  'Nourriture': nourriture,
  'Couleurs': couleurs,
  'Corps': corps,
  'Verbes': verbes,
  'Grammaire': grammaireSansAlphabet,
  'Objets du quotidien': objets
};

export default categories;